import React from 'react';
import ReactDOM from 'react-dom';
import { GlobalStyle } from './common/theme/globalStyles';
import App from './App';
import reportWebVitals from './reportWebVitals';

/* Themes */
import { ChakraProvider } from '@chakra-ui/react';
import { customTheme } from './common/theme/customChakraTheme.js';

ReactDOM.render(
  <React.StrictMode>
    <ChakraProvider resetCSS theme={customTheme}>
      <GlobalStyle />
      <App />
    </ChakraProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
